import React, { useEffect } from 'react'
import Page_Loader from '../../../assets/vizr_images/page_loader.gif';
import { useDispatch, useSelector } from 'react-redux'
import { GET_DATAGUARD_HEADER_DATA } from '../Utility/DataguardConstant';
import { calculatePercentage } from "../../SysGuard/sysGuardConstants";
import RadialProgress from './RadialProgress';

function DataguardDashboardHeader({loc}) {
  const dispatch = useDispatch();
  const totalAssetsCount = useSelector((state) => state.DataguardReducer.totalAssetsCount);
  const fromTimeStamp = useSelector(
    (state) => state.DataguardReducer.fromTimeStamp
  );
  const toTimeStamp = useSelector(
    (state) => state.DataguardReducer.toTimeStamp
  );
  const dataguardHeaderData = useSelector((state) => state.DataguardReducer.dataguardHeaderData)
  const headerLoader = useSelector((state) => state.DataguardReducer.headerLoader);
  const locationSummary = useSelector(
    (state) => state.DataguardReducer.locationSummary
  );
  const publicAccess = dataguardHeaderData?.publicAccess;
  const suspicious = dataguardHeaderData?.suspicious;
  const rolesData = useSelector((state) => state.DataguardReducer.rolesData);
  const totalUsers = (rolesData?.activeUsers || 0) + (rolesData?.inactiveUsers || 0);
  const fnGetRadialConfigs = () => {
    // Configuration for all radial charts
    const radialConfigs = [
      {
        data: {
          percentage: calculatePercentage(locationSummary?.locationAlerts, locationSummary?.noOfLocations),
          value: locationSummary?.locationAlerts || 0,
          maxValue: locationSummary?.noOfLocations || 0
        },
        title: "Location Anomalies",
        img: "/dataguardIcons/location.svg",
        alt: "location Icon",
        colors: ["#F6BD41"],
        chartRadius: ['60%', '75%'] // Larger radius
      },
      {
        data: {
          percentage: calculatePercentage(rolesData.activeUsers, totalUsers),
          value: rolesData.activeUsers || 0,
          maxValue: totalUsers || 0
        },
        title: "Active Users",
        img: "/dataguardIcons/users.svg",
        alt: "users Icon",
        colors: ["#8D06A3"],
        chartRadius: ['60%', '75%'] // Larger radius
      },
      {
        data: {
          percentage: calculatePercentage(publicAccess?.alertCount, totalAssetsCount || 0),
          value: publicAccess?.alertCount || 0,
          maxValue: totalAssetsCount || 0
        },
        title: "Total Assets",
        img: "/dataguardIcons/publicaccess.svg",
        alt: "public access Icon",
        colors: ["#E4454F"],
        chartRadius: ['60%', '75%'] // Larger radius
      },
      {
        data: {
          percentage: calculatePercentage(suspicious?.alertCount, suspicious?.totalCount),
          value: suspicious?.alertCount || 0,
          maxValue: suspicious?.totalCount || 0
        },
        title: "Suspicious User Behavior",
        img: "/dataguardIcons/suspicious.svg",
        alt: "danger Icon",
        colors: ["#E4454F"],
        isMultiSegment: true,
        chartRadius: ['60%', '75%'] // Larger radius
      }
    ];
    return radialConfigs;
  }
  useEffect(() => {
    if (fromTimeStamp && toTimeStamp) {
      dispatch({
        type: GET_DATAGUARD_HEADER_DATA,
        payload: {
          loc: "dashboard",
          fromTimeStamp,
          toTimeStamp
        }
      });
    }
  }, [fromTimeStamp, toTimeStamp, dispatch])
  if (headerLoader && loc!=="detailsPage") {
    return (
      <div className="header-loader-container">
        <div className='loader-container dataGuard'>
          <img src={Page_Loader} alt="Loading..." className='loader-img' />
        </div>
      </div>
    );
  }
  return (
    <div className= {`sys-guard-dashboard-header-container ${loc === "detailsPage" ? "detailsPage" : ""}`}>
      <RadialProgress data={fnGetRadialConfigs()} loc={loc}/>
    </div>
  )
}

export default DataguardDashboardHeader